<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>菜单管理</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" class="user-search">
            <el-form-item label="搜索：">
                <el-input size="small" v-model="formInline.name" placeholder="输入菜单名称"></el-input>
            </el-form-item>
            <el-form-item label="">
                <el-input size="small" v-model="formInline.code" placeholder="输入URL"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
            </el-form-item>
        </el-form>
        <!--列表-->
        <el-table size="small" @selection-change="selectChange" :data="listData" highlight-current-row
                  v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column align="center" type="selection" width="60"></el-table-column>
            <el-table-column sortable prop="id" label="ID" width="80"></el-table-column>
            <el-table-column sortable prop="name" label="菜单名称"></el-table-column>
            <el-table-column prop="code" label="URL"></el-table-column>
            <el-table-column prop="icon" label="ICON">
                <template slot-scope="scope">
                    <i class="iconfont" :class="scope.row.icon"></i>
                    <span>{{scope.row.icon}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="is_menu" label="是否菜单" width="80">
                <template slot-scope="scope">
                    <p>{{scope.row.is_menu == 1 ? '是' : '否'}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="status" label="是否启用" width="80">
                <template slot-scope="scope">
                    <p>{{scope.row.status == 1 ? '启用' : '禁用'}}</p>
                </template>
            </el-table-column>
            <el-table-column sortable prop="orders" label="排序" width="100"></el-table-column>
            <el-table-column align="center" label="操作" width="150">
                <template slot-scope="scope">
                    <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="deleteMenu(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <!-- 编辑界面 -->
        <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
            <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
                <el-form-item label="菜单名称" prop="name">
                    <el-input size="small" v-model="editForm.name" auto-complete="off"
                              placeholder="菜单名称"></el-input>
                </el-form-item>
                <el-form-item label="URL" prop="code">
                    <el-input size="small" v-model="editForm.code" auto-complete="off"
                              placeholder="URL"></el-input>
                </el-form-item>
                <el-form-item label="ICON" prop="icon">
                    <el-input size="small" v-model="editForm.icon" auto-complete="off"
                              placeholder="ICON"></el-input>
                </el-form-item>
                <el-form-item label="排序" prop="orders">
                    <el-input size="small" v-model="editForm.orders" auto-complete="off"
                              placeholder="排序"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">
                    保存
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {menuDelete, menus, menuSave} from '../../api/userMG'
    import Pagination from '../../components/Pagination'

    export default {
        data() {
            return {
                nshow: true, //switch开启
                fshow: false, //switch关闭
                loading: false, //是显示加载
                editFormVisible: false, //控制编辑页面显示与隐藏
                title: '添加',
                editForm: {
                    id: '',
                    name: '',
                    code: '',
                    orders: '',
                    icon: '',
                },
                // rules表单验证
                rules: {
                    name: [
                        {required: true, message: '请输入菜单名称', trigger: 'blur'}
                    ],
                    code: [
                        {required: true, message: '请输入URL', trigger: 'blur'}
                    ],
                    orders: [
                        {required: true, message: '请输入URL', trigger: 'blur'}
                    ]
                },
                formInline: {
                    page: 1,
                    limit: 10,
                    pageSize: 10,
                    permission: '',
                },
                // 选择数据
                selectdata: [],
                listData: [], //用户数据
                // 分页参数
                pageparm: {
                    currentPage: 1,
                    pageSize: 10,
                    total: 10
                }
            }
        },
        // 注册组件
        components: {
            Pagination
        },
        /**
         * 数据发生改变
         */

        watch: {},

        /**
         * 创建完毕
         */

        created() {
            this.loading = true
            this.getdata(this.formInline)
        },

        /**
         * 里面的方法只有被调用才会执行
         */

        methods: {
            // 获取数据方法
            getdata(parameter) {
                // 模拟数据
                menus(parameter).then(res => {
                    this.listData = res.items
                    this.loading = false
                    this.pageparm.currentPage = this.formInline.page
                    this.pageparm.pageSize = this.formInline.limit
                    this.pageparm.total = res.pageInfo.total
                })
            },
            // 分页插件事件
            callFather(parm) {
                this.formInline.page = parm.currentPage
                this.formInline.limit = parm.pageSize
                this.getdata(this.formInline)
            },
            // 搜索事件
            search() {
                this.getdata(this.formInline)
            },
            //显示编辑界面
            handleEdit: function (index, row) {
                this.editFormVisible = true
                // 深拷贝并赋值
                if (row != undefined && row != 'undefined') {
                    this.title = '修改'
                    this.editForm = row
                } else {
                    this.title = '添加'
                }
            },
            // 编辑、增加页面保存方法
            submitForm(editData) {
                this.$refs[editData].validate(valid => {
                    if (valid) {
                        menuSave(this.editForm)
                            .then(res => {
                                this.editFormVisible = false
                                this.loading = false
                                if (res.code == 200) {
                                    this.getdata(this.formInline)
                                    this.$message({
                                        type: 'success',
                                        message: '菜单保存成功！'
                                    })
                                } else {
                                    this.$message({
                                        type: 'info',
                                        message: res.msg
                                    })
                                }
                            })
                            .catch(err => {
                                this.editFormVisible = false
                                this.loading = false
                                this.$message.error('菜单保存失败，请稍后再试！')
                            })
                    } else {
                        return false
                    }
                })
            },
            // 删除菜单
            deleteMenu(row) {
                this.$confirm('确定要删除吗?', '信息', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        menuDelete({id: row.id})
                            .then(res => {
                                if (res.code == 200) {
                                    this.$message({
                                        type: 'success',
                                        message: '菜单已删除！'
                                    })
                                    this.getdata(this.formInline)
                                } else {
                                    this.$message({
                                        type: 'info',
                                        message: res.msg
                                    })
                                }
                            })
                            .catch(err => {
                                this.loading = false
                                this.$message.error('菜单删除失败,请稍后再试！')
                            })
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        })
                    })
            },
            // 选择复选框事件
            selectChange(val) {
                this.selectdata = val
            },
            // 关闭编辑、增加弹出框
            closeDialog() {
                this.editFormVisible = false
                this.editForm = {
                    id: '',
                    name: '',
                    code: '',
                    orders: '',
                    icon: '',
                };
            }
        }
    }
</script>

<style scoped>
    .user-search {
        margin-top: 20px;
    }

    .userRole {
        width: 100%;
    }
</style>

 


// WEBPACK FOOTER //
// src/views/auth/menu.vue